import React, { useEffect, useState,useRef } from 'react';
import { BrowserRouter as Router, Route, Link, useParams, useNavigate } from 'react-router-dom';
import { AxiosInstance } from '../utils';
import "../../css/bootstrap.min.css";
import "../../css/animate.min.css";
import "../../css/style.css";
import "../../css/responsive.css";
import "../../css/light-color.css";
import "../../css/floatlabel.css";
import "../../css/customstyle.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { HeaderNoMenu } from '../sections/headernomenu';
import ScrollToTop from 'react-scroll-to-top';
import { ToastContainer, toast } from 'react-toastify';
import QRScanner from './QRScanner';
function sleep(ms: any) {
    return new Promise(resolve => setTimeout(resolve, ms));
}


function CheckinComponent() {
    const [loading, setLoading] = useState(true);
    const [eventresp, setEventresp] = useState({} as any);
    const [checkinconfresp, setCheckinconfresp] = useState({} as any);
    const [ticketDetails, setTicketDetails] = useState(null as any);
    const ticketRef = useRef(null as any);
    const navigate = useNavigate();
    const { eventcode,checkinkey, checkinfield } = useParams();
    const queryParams = new URLSearchParams(window.location.search);
    const ticketkey = queryParams.get("ticketkey");
    const errmsg = queryParams.get("msg");
    
    
    useEffect(() => {
        if (eventcode == null) {
            navigate('/pagenotfound');
        }

        const fetchData = async () => {

            setLoading(true);

            const { data: response } = await AxiosInstance.get('/api/getcheckin?eventcode=' + eventcode + '&checkinkey='+checkinkey + '&checkinfield='+checkinfield);
           
            if (response.result != "Success" || response.data?.length == 0) {
                setLoading(false);
                navigate('/pagenotfound');
            }
            setLoading(false);
            setCheckinconfresp(response.data);
        }

  


        fetchData();
    }, [navigate]);

   
    if (loading) {
        return (<div id="preloader">
            <div id="status">
                <div className="spinner"></div>
            </div>
        </div>);
    }
    else {
        return (
            <>
            <HeaderNoMenu />
            {checkinconfresp && <div className="antialiased light-vz circle-v ">

        
        <section className="sec-padding" id="checkin" data-scroll-index="3">

<div className="container">
    <div className="sec-title  white-heading-text">
        <span className="icon-inner wow flipInY" data-wow-duration="300ms"><span className="fa-stack"><i className="fa rhex fa-stack-2x"></i><i className="fa fa-qrcode fa-stack-1x"></i></span></span>
        <h3 className="wow fadeInRight" data-wow-duration="500ms">{checkinfield} - {eventcode} </h3>
    </div> {/* <!--sec-title end--> */}


    <div className="partner-sec">
     

    {checkinconfresp &&   <QRScanner />}
    </div> {/* <!--partner-sec end--> */}
</div>
</section>
             



                

                <footer>
                    <div className="container">
                        <ul className="social-line list-inline">
                            <li className="wow flipInY" data-wow-duration="200ms"><a href="https://x.com/bsidesbangalore" className="twitter"><i className="fa fa-twitter"></i></a></li>
                            <li className="wow flipInY" data-wow-duration="300ms"><a href="https://www.youtube.com/channel/UC0SqOU2NDDIP0bbt5OwW8Hw" className="google"><i className="fa fa-youtube"></i></a></li>
                            <li className="wow flipInY" data-wow-duration="400ms"><a href="https://lnkd.in/gZ8N3Kxr" className="linkedin"><i className="fa fa-linkedin"></i></a></li>
                            <li className="wow flipInY" data-wow-duration="500ms"><a href="https://www.instagram.com/bsides_bangalore" className="instagram"><i className="fa fa-instagram"></i></a></li>
                        </ul>
                        <p>© 2025 BSides Bangalore</p>
                    </div>
                </footer>

                
                <ScrollToTop  component={<i className="fa fa-angle-up"></i>} smooth />
                <ToastContainer position="bottom-right"/>
                </div>}
            </>
        );
    }
}
export default CheckinComponent;
